import {
  ADPCredentialsExist,
  CoreEntityDomainsOrganizationsEntrypointsApiV2SchemasResponseHRISIntegration as HRISIntegrationDto,
  CoreEntityDomainsOrganizationsEntrypointsApiV1SchemasResponseHRISProvider as HRISProviderDto,
  HRISIntegrationSyncResponse,
  HRISIssue,
  WorkflowStatus,
} from '@electricjs/core_entity-client';

export const simpleHrisIssue: HRISIssue = {
  id: '123-test',
  status: 'ONGOING',
  error_description: 'Error description',
  error_details: ['Error detail 1', 'Error detail 2'],
};

export const hrisProviders: HRISProviderDto[] = [
  { id: 'hris-provider-bamboohr', name: 'BambooHR', slug: 'bamboohr' },
  { id: 'hris-provider-gusto', name: 'Gusto', slug: 'gusto' },
  { id: 'hris-provider-paylocity', name: 'Paylocity', slug: 'paylocity' },
];

export const createHrisIntegrationResponse = (
  organizationId: string,
  providerSlug: string
): HRISIntegrationDto => {
  const provider =
    hrisProviders.find(p => p.slug === providerSlug) ?? hrisProviders[0];
  return {
    id: `hris-integration-${providerSlug}`,
    organization_id: organizationId,
    hris_provider: provider,
    created_by: 'mock-user',
  };
};

export const hrisSyncWorkflowResponse: HRISIntegrationSyncResponse = {
  workflow_id: 'mock-sync-workflow-id',
};

export const hrisSyncStatusResponse: WorkflowStatus = {
  workflow_id: hrisSyncWorkflowResponse.workflow_id,
  status: 'COMPLETED',
};

export const adpCredentialsExistResponse: ADPCredentialsExist = {
  exists: true,
};
